import './App.css';
import Navbar from './Navbar';
import Carousel from './carousel';
import Footer from './footer';

function App() {
  return (
    <div>
      <Navbar/>
      <div className="App">
      
      <Carousel/>
    </div>
    <Footer/>
    </div>
  );
}

export default App;
